import React from 'react';
import RcSlider from 'rc-slider';
// Types
import { SliderProps } from 'rc-slider';

import styles from './Slider.module.scss';

const Slider: React.FC<SliderProps> = ({ ...rest }) => {
  const handleStyle = {
    width: '18px',
    height: '18px',
    backgroundColor: '#FFFFFF',
    border: '2px solid #d8a445',
    borderRadius: '100%',
  };

  const trackStyle = {
    height: '5px',
    backgroundColor: '#d8a445',
    border: '0.5px solid #939393',
    borderRadius: '10px',
    marginTop: '5px',
    transform: 'translate(0)',
  };

  return (
    <div className={styles.sliderWrapper}>
      <RcSlider
        className={styles.sliderContainer}
        handleStyle={handleStyle}
        trackStyle={trackStyle}
        railStyle={{
          ...trackStyle,
          backgroundColor: '#ffffff',
          marginTop: '5px',
        }}
        dotStyle={{
          display: 'none',
        }}
        activeDotStyle={{
          display: 'none',
        }}
        {...rest}
      />
    </div>
  );
};

export default Slider;
